
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"a","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 64 64"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M32,12.66l5.17,10.49,1.4,2.83,3.12.45,11.56,1.68-8.36,8.16-2.26,2.2.53,3.11,1.98,11.55-10.36-5.44-2.79-1.47-2.79,1.46-10.34,5.42,2-11.5.54-3.11-2.26-2.21-8.38-8.17,11.54-1.67,3.12-.45,1.4-2.83,5.17-10.49M32,1.45c-.28,0-.56.06-.82.19-.37.18-.68.48-.86.86l-8.87,18L1.61,23.38c-1.02.16-1.72,1.12-1.56,2.14.06.41.26.78.56,1.06l14.35,14-3.43,19.75c-.12.71.17,1.42.75,1.84.32.23.71.36,1.1.36.3,0,.6-.08.87-.22l17.75-9.31,17.75,9.33c.28.14.58.21.87.21.68,0,1.33-.37,1.67-1.01.19-.37.26-.79.18-1.2l-3.39-19.76,14.35-14c.51-.5.69-1.23.48-1.91-.22-.68-.81-1.18-1.52-1.28l-19.84-2.88L33.68,2.5c-.32-.66-.99-1.05-1.68-1.05h0Z"}})])
          )
        }
      }
    